export default {"src":"/_next/static/media/upload-complete.889442b4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};